import {
    QueryFunction,
} from '@tanstack/react-query'
import {
    failedToLoadSaveForm,
} from 'app/shared-components/FormStatuses/store/actions'
import {
    TableResponse,
    DataRequest,
    SpecRequest,
} from 'app/types/request.types'

type Props<ResponseData = TableResponse | Record<string, any>> = {
    paramFn: (args: Record<string, any>) => SpecRequest,
    requestFn: (params: DataRequest) => Promise<{ data: any }>,
    parserFn: (args: Promise<any>) => Promise<ResponseData>,
}

const requestFunctionBuilder = <ResponseData>({
    paramFn,
    requestFn,
    parserFn,
}: Props<ResponseData>): ((dispatch: any) => QueryFunction<ResponseData>) => {
    return (dispatch) => {
        return (async ({
            queryKey: [
                _key, // eslint-disable-line @typescript-eslint/no-unused-vars
                queryParams,
            ],
        }) => {
            const {
                token, ...rest
            } = queryParams as { token: string; [key: string]: any }

            return parserFn(requestFn({
                token,
                ...paramFn({
                    ...rest,
                }),
            })).catch((error) => {
                const {
                    response: {
                        data: errors,
                        status: statusCode,
                    },
                } = error

                dispatch(
                    failedToLoadSaveForm({
                        id: 'useRequestId',
                        errors,
                        statusCode,
                    }),
                )
            })
        }) as QueryFunction<ResponseData>
    }
}

export default requestFunctionBuilder
